import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import { OrdersetCategoryFooter, OrdersetCategoryTestSelection } from './components'
import { CategoryPanel, CompendiumPanelWithType, PackageCategoryPanel } from '../../../../../types'

const OrdersetCategoryLayout = styled.div`
  display: flex;
  flex-flow: column nowrap;
  border: 1px solid #e5e5e5;
  width: 100%;
  margin-top: 10px;
  padding: 20px;
  gap: 10px;
  align-items: center;
  align-content: center;
`
export interface OrdersetCategoryProps {
  category: PackageCategoryPanel
  handleOrdersetCategoryChange: React.Dispatch<React.SetStateAction<PackageCategoryPanel[]>>
}

export const OrdersetCategory = (props: OrdersetCategoryProps) => {
  const { category, handleOrdersetCategoryChange } = props

  const [selectedTests, setSelectedTests] = useState<CompendiumPanelWithType[]>([])

  const isSaveCategoryButtonDisabled = [...selectedTests].length <= 0

  useEffect(() => {
    handleSaveEditOrdersetCategoryClick()
  }, [selectedTests])

  const handleRemoveOrdersetCategory = () => {
    handleOrdersetCategoryChange((prevItems) => prevItems.filter((item) => item.id !== category.id))
  }

  const handleSaveEditOrdersetCategoryClick = () => {
    const groupTests: CategoryPanel[] = selectedTests.map((test) => ({
      type: 'group',
      tests: test.tests.map((t) => {
        return t._id
      }),
    }))

    const categoryPayload: PackageCategoryPanel = {
      id: category.id,
      category_id: category.category_id,
      panels: [...groupTests],
    }

    handleOrdersetCategoryChange((prevItems) => prevItems.map((item) => (item.id === category.id ? categoryPayload : item)))
  }

  return (
    <OrdersetCategoryLayout>
      <OrdersetCategoryTestSelection
        selectedTests={selectedTests}
        handleSelectedTestsChange={setSelectedTests}
        handleSaveEditOrdersetCategoryClick={handleSaveEditOrdersetCategoryClick}
      />

      <OrdersetCategoryFooter
        isSaveCategoryButtonDisabled={isSaveCategoryButtonDisabled}
        handleRemoveOrdersetCategory={handleRemoveOrdersetCategory}
      />
    </OrdersetCategoryLayout>
  )
}
